import { CreateAcademicYearType } from "../../../types/AcademicYear";
import { post } from "../../../utils/axios-config";
import { ACADEMICYEARS } from "../../../utils/constants";

export const createAcademicYear = async (data: CreateAcademicYearType) => await post<CreateAcademicYearType, string>(ACADEMICYEARS, data);